import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function CreatorSection() {
  return <section className="py-16 px-4 bg-blue text-ice relative overflow-hidden" data-id="element-24">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/church.png')] opacity-10 mix-blend-overlay" data-id="element-25" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-26">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-27">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2 flex justify-center" data-id="element-28">
            <div className="relative" data-id="element-29">
              <div className="absolute inset-0 bg-gold/30 blur-2xl rounded-full" data-id="element-30" />
              <img src="https://cdn.magicpatterns.com/uploads/v7auVdwZbxT5RxLfSzkTuP/monga.png" alt="La Hermana Teresa R." className="relative z-10 w-72 h-72 md:w-96 md:h-96 object-cover rounded-full border-4 border-gold shadow-[0_0_40px_rgba(197,148,42,0.4)]" data-id="element-31" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-1/2 text-center md:text-left" data-id="element-32">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-gold-light mb-4" data-id="element-33">
              La Hermana Teresa R.
            </h2>

            <p className="font-body text-xl text-ice/80 italic mb-8" data-id="element-34">
              "Aunque todos la conocen como Teresita, la de los milagros..."
            </p>

            <div className="space-y-6 font-body text-lg text-ice-light leading-relaxed" data-id="element-35">
              <p data-id="element-36">
                Con décadas de servicio en comunidades vulnerables, la Hermana
                Teresa ha sido testigo del dolor que causa la inseguridad en las
                familias.
              </p>
              <p data-id="element-37">
                Fue esta profunda compasión la que la llevó a compilar y
                estructurar el{' '}
                <strong className="text-gold" data-id="element-38">Escudo de Fe</strong>, reuniendo
                las oraciones de protección más poderosas que han resguardado a
                miles de hogares en los momentos más oscuros.
              </p>
              <p data-id="element-39">
                "No podemos controlar lo que pasa afuera, pero sí podemos
                blindar nuestro hogar con la luz divina", asegura Teresita.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}